import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTrackerContext } from "@dpdgroupuk/react-event-tracker";
import clsx from "clsx";
import { getCurrentYear } from "../../utils/helpers";
import { FOOTER_DESKTOP_HEIGHT, FOOTER_MOBILE_HEIGHT } from "../../constants/values";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: FOOTER_DESKTOP_HEIGHT,
    position: "relative",
    [breakpoints.down("xs")]: {
      height: FOOTER_MOBILE_HEIGHT
    },
    [breakpoints.up("sm")]: {
      marginTop: typography.pxToRem(20)
    }
  },
  rowContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    [breakpoints.down("xs")]: {
      flexWrap: "wrap"
    }
  },
  dot: {
    padding: `0 ${typography.pxToRem(10)}`,
    color: palette.text.primary,
    fontSize: typography.pxToRem(10)
  },
  text: {
    color: palette.text.primary,
    fontSize: typography.pxToRem(10),
    fontWeight: 300,
    letterSpacing: 0.44,
    lineHeight: 1.7,
    [breakpoints.down("xs")]: {
      letterSpacing: 0.41
    }
  },
  copyright: {
    paddingRight: typography.pxToRem(15),
    [breakpoints.down("xs")]: {
      paddingRight: typography.pxToRem(5)
    }
  }
}));

const Item = ({
  title,
  url,
  id,
  analytics
}) => {
  const styles = useStyles();
  const tracker = useTrackerContext();
  const onFooterClick = React.useCallback(() => {
    analytics && tracker.logEvent(analytics[id]);
  }, [id, analytics, tracker]);
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: styles.rowContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.dot
  }, "\u2022"), /*#__PURE__*/React.createElement(Link, {
    className: styles.text,
    underline: "none",
    href: url,
    target: "_blank",
    onClick: onFooterClick
  }, title));
};

const Footer = ({
  className,
  analytics
}) => {
  const styles = useStyles();
  const {
    dpdSiteUrl
  } = useTheme();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "baseline",
    className: clsx(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rowContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.copyright, styles.text)
  }, `© ${getCurrentYear()} DPD.`)), /*#__PURE__*/React.createElement(Item, {
    id: "TERMS",
    title: "Terms & Conditions",
    url: `${dpdSiteUrl}/ts-and-cs.jsp`,
    analytics: analytics
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rowContainer
  }, /*#__PURE__*/React.createElement(Item, {
    id: "PRIVACY",
    title: "Privacy Notice",
    url: `${dpdSiteUrl}/privacy_policy.jsp`,
    analytics: analytics
  }), /*#__PURE__*/React.createElement(Item, {
    id: "PHISHING",
    title: "Phishing",
    url: `${dpdSiteUrl}/content/about_dpd/phishing.jsp`,
    analytics: analytics
  })));
};

export default Footer;